module.exports = __webpack_public_path__ + "static/testi-9-2a5f7fea2b4976ad49c2634b41c5451f.jpg";